import { useQuery, UseQueryOptions } from "react-query";

import { SampleRequest, SampleRequestService } from "../api/public";

export const sampleRequestsQueryKey = (limit?: number) => [
  "sample-requests",
  limit,
];

export const useGetSubmittedSampleRequestsQuery = (
  limit?: number,
  options?: UseQueryOptions<
    SampleRequest[],
    unknown,
    SampleRequest[],
    (string | number | undefined)[]
  >
) => {
  return useQuery(
    sampleRequestsQueryKey(limit),
    async () =>
      SampleRequestService.sampleRequestGetSubmittedSampleRequests(limit).then(
        ({ data }) => data
      ),
    options
  );
};
